const defaultApiBaseUrl = import.meta.env.DEV
  ? "http://localhost:8787"
  : "https://anemoi.silver-taza.workers.dev";

export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || defaultApiBaseUrl,
  meUrl: `${import.meta.env.VITE_API_BASE_URL || defaultApiBaseUrl}/api/me`,

  // Microsoft Clarity ID
  clarityId: "uhq0r16ib2",
} as const;

// Feature flags for dark launching
// Set these in wrangler.toml (prod) or .dev.vars (dev)
export const FEATURES = {
  // Enable WorkOS authentication UI (Log in link + surfaces AuthKit in header)
  enableAuth: import.meta.env.VITE_ENABLE_AUTH === "true",

  // Enable billing/subscription UI
  enableBilling: import.meta.env.VITE_ENABLE_BILLING === "true",
} as const;
